//@flow
import React, { useState } from "react";
import { View, Text, Dimensions, Image } from "react-native";
import SignupHeader from "mobile/src/scenes/Signup/SignupHeader";
import SignupBottom from "mobile/src/scenes/Signup/SignupBottom";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
// import * as Animatable from "react-native-animatable";
import Theme from "@microdoing/shared/constants/Theme";
import Fonts from "@microdoing/shared/constants/Fonts";
import { MainText, Slider } from "mobile/src/components/common";
import { Box } from "mobile/src/components/common/Box/MainBox/MainBox";
import theme from "app/Theme/Theme";

const ConfidenceImage = require("../../../assets/images/confidence.png");
const TeamImage = require("../../../assets/images/team.png");
const SpeakingImage = require("../../../assets/images/speaking.png");
const StressImage = require("../../../assets/images/stress.png");
const PeaceImage = require("../../../assets/images/peace.png");

const { width, height } = Dimensions.get("window");

const components = [
  {
    value: "confidence",
    title: "feeling1-title",
    image: ConfidenceImage,
    leftLabel: "less well",
    rightLabel: "better",
  },
  {
    value: "stress",
    title: "feeling2-title",
    image: StressImage,
    leftLabel: "less well",
    rightLabel: "better",
  },
  {
    value: "publicSpeaking",
    title: "feeling3-title",
    image: SpeakingImage,
    leftLabel: "less well",
    rightLabel: "better",
  },
  {
    value: "teamCohesion",
    title: "feeling4-title",
    image: TeamImage,
    leftLabel: "less well",
    rightLabel: "better",
  },
  {
    value: "productivity",
    title: "feeling5-title",
    image: PeaceImage,
    leftLabel: "less well",
    rightLabel: "better",
  },
];

interface ISlide {
  value: number;
  firstTitle: string;
  secondTitle: string;
  onValueChange: () => null;
  image: number;
  leftLabel: string;
  rightLabel: string;
}

interface IProps {
  changeProgress: () => null;
  progressRatio: number;
  requesting: boolean;
  headerTitle: string;
  progress: number;
  slides: ISlide[];
  goNext: () => null;
  goBack: () => null;
}

const ImageSliders = ({
  changeProgress,
  progressRatio,
  requesting,
  headerTitle,
  progress,
  slides,
  goNext,
  goBack,
}: IProps) => {
  const [index, setIndex] = useState(0);

  const goBackStep = () => {
    setIndex(index - 1);
    changeProgress(-progressRatio);
  };

  const goNextStep = () => {
    setIndex(index + 1);
    changeProgress(progressRatio);
  };

  const renderItem = slides => {
    return slides.map((el, i) => {
      return (
        index === i && (
          <View key={i} style={styles.bodyView}>
            {/* <Animatable.View
              useNativeDriver
              animation={i ? "fadeInLeft" : null}
              style={[styles.middleViewStyle]}
            > */}
            <MainText
              variant="l6-medium"
              textAlign="center"
              marginBottom="xl"
              marginTop="m"
              alignSelf="center"
              width={wp("75%")}
            >
              {el.firstTitle}{" "}
              <MainText variant="l6-bold">{el.secondTitle}</MainText>
            </MainText>
            <Image
              source={el.image}
              style={styles.image}
              resizeMode="contain"
            />
            {/* </Animatable.View> */}
            <View style={styles.bottomViewStyle}>
              <View style={styles.sliderPosition}>
                <Slider
                  value={el.value}
                  onValueChange={el.onValueChange}
                  leftLabel={el.leftLabel}
                  rightLabel={el.rightLabel}
                  minimumValue={0}
                  maximumValue={10}
                />
              </View>
              <SignupBottom
                testID={`next-button-slide-${i}`}
                rightButtonText={
                  i === components.length - 1 ? "submit" : "signup-next-button"
                }
                noLeftButton={false}
                onPressBack={i === 0 ? goBack : goBackStep}
                onPressNext={i === slides.length - 1 ? goNext : goNextStep}
                isRequesting={requesting}
              />
            </View>
          </View>
        )
      );
    });
  };

  return (
    <Box flex={1}>
      <SignupHeader
        title={headerTitle}
        progress={progress}
        scrollEnabled={false}
      />
      {renderItem(slides)}
    </Box>
  );
};

const styles = {
  bodyView: {
    flex: 1,
  },
  middleViewStyle: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  bottomViewStyle: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  sliderPosition: {
    marginBottom: 20,
  },
  mainTextStyle: {
    ...Fonts.montserrat.regular,
    textAlign: "center",
    marginBottom: 50,
    marginTop: 20,
    alignSelf: "center",
    width: wp("75%"),
    fontSize: Theme.FONT_SIZE_EXTRA_LARGE,
    lineHeight: Theme.FONT_SIZE_EXTRA_LARGE * 1.4,
    fontWeight: "normal",
    color: theme.colors["neutral.900"],
  },
  image: {
    alignSelf: "center",
    height: (height * 1) / 3,
    width: width / 2,
  },
};

export { ImageSliders };
